import { GetWasteShipmentQuery } from "generated-graphql/graphql";

import { SHIPMENT_REFETCH_QUERIES } from "./api";

/** The detail query's shipment shape, shared by the page and its dialogs. */
export type Shipment = NonNullable<GetWasteShipmentQuery["wasteShipment"]>;

/**
 * What every shipment mutation has to re-read. Aliased rather than imported
 * directly at each call site so the detail page and its dialogs cannot drift
 * onto different lists.
 */
export const REFETCH = SHIPMENT_REFETCH_QUERIES;
